import React, { useState, useEffect } from "react";
import {
    Box,
    Text,
    VStack,
    HStack,
    Image,
    Button,
    Flex,
    Spacer,
    useColorModeValue,
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import { fetchBlogPosts } from "../api/mockBlogApi";

const BlogList = () => {
    const [blogPosts, setBlogPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const postsPerPage = 5; // Number of posts per page

    const bg = useColorModeValue("white", "gray.800");
    const textColor = useColorModeValue("gray.800", "white");
    const cardBg = useColorModeValue("gray.50", "gray.700");

    useEffect(() => {
        const getBlogPosts = async () => {
            const { posts, totalPages: fetchedTotalPages } = await fetchBlogPosts(
                currentPage,
                postsPerPage
            );
            setBlogPosts(posts);
            setTotalPages(fetchedTotalPages);
        };
        getBlogPosts();
    }, [currentPage]);

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <Layout title="WAGER STREET BLOG">
            <Box p={4}>
                <Text fontSize="3xl" fontWeight="bold" mb={6} color={textColor}>
                    Latest Blog Posts
                </Text>
                <VStack spacing={8} align="stretch">
                    {blogPosts.map((post) => (
                        <NavLink to={`/blog/${post.id}`} key={post.id}>
                            <Box
                                p={5}
                                shadow="md"
                                borderWidth="1px"
                                borderRadius="lg"
                                bg={cardBg}
                                _hover={{ transform: "translateY(-5px)", shadow: "lg" }}
                                transition="all 0.2s ease-in-out"
                            >
                                <HStack align="start" spacing={4}>
                                    {post.image && (
                                        <Image
                                            src={post.image}
                                            alt={post.title}
                                            boxSize="150px"
                                            objectFit="cover"
                                            borderRadius="md"
                                        />
                                    )}
                                    <VStack align="start" spacing={1}>
                                        <Text fontSize="2xl" fontWeight="bold" color="purple.400">
                                            {post.title}
                                        </Text>
                                        <Text fontSize="sm" color="gray.500">
                                            By {post.author} on {post.date}
                                        </Text>
                                        <Text mt={2} color={textColor}>
                                            {post.content.substring(0, 150)}...
                                        </Text>
                                        <Button size="sm" colorScheme="purple" variant="link">
                                            Read More
                                        </Button>
                                    </VStack>
                                </HStack>
                            </Box>
                        </NavLink>
                    ))}
                </VStack>

                <Flex mt={8} justify="center" align="center">
                    <Button
                        onClick={handlePreviousPage}
                        isDisabled={currentPage === 1}
                        colorScheme="purple"
                        variant="outline"
                    >
                        Previous
                    </Button>
                    <Text mx={4} color={textColor}>
                        Page {currentPage} of {totalPages}
                    </Text>
                    <Button
                        onClick={handleNextPage}
                        isDisabled={currentPage === totalPages}
                        colorScheme="purple"
                        variant="outline"
                    >
                        Next
                    </Button>
                </Flex>
            </Box>
        </Layout>
    );
};

export default BlogList;